import React, { useState } from "react";
import { ScanLine, Camera, Ruler, ArrowRight } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { AreaCalculator } from "@/components/AreaCalculator";
import { DEFAULT_PARAMS, num } from "@/lib/calc";

export default function MeasureView({ autoOpen = false }) {
  const { t, setView, setQuoteDraft } = useApp();
  const [open, setOpen] = useState(autoOpen);

  const confirm = (total, rooms) => {
    const area = Number(num(total).toFixed(2));
    setOpen(false);
    setQuoteDraft({
      product: null,
      params: { ...DEFAULT_PARAMS, area_m2: area },
      fromMeasure: true,
      area,
      rooms: Array.isArray(rooms) ? rooms : [],
    });
    setView("quote");
  };

  return (
    <div className="mx-auto max-w-2xl" data-testid="measure-view">
      <div className="mb-8">
        <div className="mb-3 flex items-center gap-2 text-primary">
          <span className="flex h-9 w-9 items-center justify-center bg-primary/15">
            <ScanLine className="h-5 w-5" />
          </span>
          <span className="label-caps">{t("navMeasure")}</span>
        </div>
        <h1 className="font-display text-3xl font-black tracking-tight sm:text-4xl">
          {t("measureTitle")}
        </h1>
        <p className="mt-3 text-base text-muted-foreground">{t("measureBody")}</p>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div className="flex items-start gap-3 border border-border bg-surface p-4">
          <Camera className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
          <p className="text-sm text-muted-foreground">AR / LIDAR · {t("measureFab")}</p>
        </div>
        <div className="flex items-start gap-3 border border-border bg-surface p-4">
          <Ruler className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
          <p className="text-sm text-muted-foreground">L × P (m) · m²</p>
        </div>
      </div>

      <Button
        data-testid="measure-start-btn"
        onClick={() => setOpen(true)}
        className="mt-6 w-full rounded-none bg-primary py-6 text-base font-bold text-primary-foreground hover:opacity-90"
      >
        <ScanLine className="mr-2 h-5 w-5" /> {t("measureStart")}
        <ArrowRight className="ml-2 h-5 w-5" />
      </Button>

      <AreaCalculator open={open} onClose={() => setOpen(false)} onConfirm={confirm} />
    </div>
  );
}
